import Component from '../abstracts/Component';
import { Matchmq } from "../utils/ResolutionHandler";

export default class SizeTableSwitcherComponent extends Component {
  get SELECTORS() {
    return {
      sizes: '.l-s-g__size-row__sizes',
      sizeRow: '.l-s-g__size-row',
      scrollButton: '.scroll-sizes',

    };
  }

  constructor() {
    super();
  }

  bindEvents() {
    let ctx = this;
    $(document).on('click', this.SELECTORS.scrollButton, function (event) {
      let buttonParent = this.parentElement;
      let sizesToScroll = $(buttonParent).find('.l-s-g__size-row__sizes__wrapper')[0];
      $(sizesToScroll).animate({
        scrollLeft: "+=300px"
      }, 1800);
    });
  }

  checkLabels() {
    let labelSizes = document.querySelectorAll(this.SELECTORS.sizes).forEach(function (label) {
      if (label.dataset.localeLabel.length > 14) {
        $(label).addClass('resized');
        $(label).find('.mobile-label').addClass('resized');
      }
    });
  }

  checkCtas() {
    let sizeRows = document.querySelectorAll(this.SELECTORS.sizeRow);
    let ctx = this;
    sizeRows.forEach(function (sizeRow) {
      let firstRow = sizeRow.getElementsByClassName('l-s-g__size-row__sizes')[0];
      let sizes = firstRow.getElementsByTagName('span').length;
      if (sizes > 5 ) {
        let cta = sizeRow.getElementsByTagName('a')[0];
        $(cta).addClass('visible');
      }
    });
  }

  render() {
    if (document.querySelector('.l-s-g__size-types') && Matchmq('640','0' )===true) {
      this.bindEvents();
      this.checkLabels();
      this.checkCtas();
    }
  }
}
